import { useContext } from 'react';
import styled from 'styled-components';
import TranslationsContext from 'providers/translationsProvider';

export const MAIN_CONTENT_ID = 'main-content';

const SkipLink = styled.a`
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: 100000;

  &:focus {
    position: fixed;
    top: 8px;
    left: 8px;
    width: auto;
    height: auto;
    padding: 12px 24px;
    background-color: #1f1f1f;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;

const SkipTarget = styled.div`
  scroll-margin-top: ${({ theme }) => theme.appBarHeaderHeight};
`;

const SkipToMainContent = () => {
  const { t } = useContext(TranslationsContext);

  return (
    <SkipLink href={`#${MAIN_CONTENT_ID}`}>
      {t('Skip to main content')}
    </SkipLink>
  );
};

SkipToMainContent.Target = () => (
  <SkipTarget id={MAIN_CONTENT_ID} tabIndex={-1} />
);

export default SkipToMainContent;
